import React, { HTMLInputTypeAttribute } from 'react';
import classNames from 'classnames';
import FormLabel from './FormLabel';
import FormHint from './FormHint';

interface InputProps {
  children: React.ReactNode,
  label: string,
  labelHidden: boolean,
  type: HTMLInputTypeAttribute
  name?: string
  status?: string
  disabled?: boolean
  value?: string
  formGroup?: string
  hasIcon: string
  size?: string
  placeholder: string
  rows?: number
  hint?: string
  id: string
  onChange?: React.ChangeEventHandler<HTMLTextAreaElement> & React.ChangeEventHandler<HTMLInputElement>,
  onSubmit?: React.FormEventHandler<HTMLTextAreaElement> & React.FormEventHandler<HTMLInputElement>,
  className?: string
}

const Input = ({
  className,
  children,
  label,
  labelHidden,
  type,
  name,
  status,
  disabled,
  value,
  formGroup,
  hasIcon,
  size,
  placeholder,
  rows,
  hint,
  id,
  onChange,
  onSubmit,
  ...props
}: InputProps) => {

  const wrapperClasses = classNames(
    (formGroup && formGroup !== '') && (formGroup === 'desktop' ? 'form-group-desktop' : 'form-group'),
    (hasIcon && hasIcon !== '') && 'has-icon-' + hasIcon
  );

  const classes = classNames(
    'form-input',
    size && `form-input-${size}`,
    status && `form-${status}`,
    className
  );

  const Component = type === 'textarea' ? 'textarea' : 'input';
  return (
    <>
      {label && <FormLabel labelHidden={labelHidden} id={id}>{label}</FormLabel>}
      <div
        className={wrapperClasses}
      >
        <Component
          {...props}
          type={type !== 'textarea' ? type : undefined}
          className={classes}
          name={name}
          disabled={disabled}
          value={value}
          placeholder={placeholder}
          onChange={onChange}
          onSubmit={onSubmit}
          rows={type === 'textarea' ? rows : undefined}
        />
        {children}
      </div>
      {hint && <FormHint status={status || ''}>{hint}</FormHint>}
    </>
  );
};

export default Input;
